import { styled } from '@mui/material/styles'
import React from 'react'
import {
  ArrayInput,
  FormDataConsumer,
  SelectInput,
  SimpleFormIterator,
} from 'react-admin'
import { Rule, ThenClause } from 'services/api/entities/Rules'
import {
  ruleActionChoices,
  ruleTargetTypeChoices,
  serviceDiscriminatorChoices,
} from 'services/cfg/form'
import { thenClauseTargettableServices } from 'services/cfg/rules'
import { FormDataConsumerProps } from 'types/common'
import KToolTip from 'ui-shared/KTooltip'
import Kdivider from 'ui-shared/LayoutComponents/Kdivider'
import ProductsByServiceSelector from './ProductsByServiceSelector'

const PREFIX = 'ThenClauseForm'

const classes = {
  dFlexRow: `${PREFIX}-dFlexRow`,
  inputW250px: `${PREFIX}-inputW250px`,
  inputW800px: `${PREFIX}-inputW800px`,
  w100: `${PREFIX}-w100`,
}

// TODO jss-to-styled codemod: The Fragment root was replaced by div. Change the tag if needed.
const Root = styled('div')({
  [`& .${classes.dFlexRow}`]: {
    display: 'flex',
    flexDirection: 'row',
    gap: '10px',
    width: '100%',
  },
  [`& .${classes.inputW250px}`]: {
    width: '250px',
  },
  [`& .${classes.inputW800px}`]: {
    width: '800px',
  },
  [`& .${classes.w100}`]: {
    width: '100%',
  },
})

const ThenClauseForm: React.FC = (props) => {
  return (
    <Root>
      <Kdivider title="THEN" />
      <ArrayInput
        {...props}
        label=""
        source="then"
        fullWidth
        className={classes.w100}
      >
        <SimpleFormIterator>
          <FormDataConsumer>
            {({
              scopedFormData,
              getSource,
            }: FormDataConsumerProps<Rule, ThenClause>) => {
              // the array of selectable choices
              const selectableServices = scopedFormData
                ? thenClauseTargettableServices[scopedFormData.targetType]
                : []

              // filter the choices of services with the selectable services
              const serviceAvailableChoices = serviceDiscriminatorChoices.filter(
                (e) => selectableServices?.includes(e.id)
              )

              return (
                !!getSource && (
                  <div className={classes.dFlexRow}>
                    <KToolTip
                      title="form.fields.ruleActionTooltip"
                      placement="top"
                    >
                      <SelectInput
                        {...props}
                        label="form.fields.ruleAction"
                        className={classes.inputW250px}
                        source={getSource('action')}
                        choices={ruleActionChoices}
                        defaultValue="suggest"
                      />
                    </KToolTip>

                    <KToolTip
                      title="form.fields.ruleTargetTypeTooltip"
                      placement="top"
                    >
                      <SelectInput
                        {...props}
                        label="form.fields.targetType"
                        source={getSource('targetType')}
                        choices={ruleTargetTypeChoices}
                        className={classes.inputW250px}
                      />
                    </KToolTip>
                    <ProductsByServiceSelector
                      {...props}
                      serviceChoices={serviceAvailableChoices}
                      getSource={getSource}
                      scopedFormData={scopedFormData}
                      serviceTooltipText="form.fields.thenClauseServiceTooltip"
                      productsTooltipText="form.fields.thenClauseProductsTooltip"
                    />
                  </div>
                )
              )
            }}
          </FormDataConsumer>
        </SimpleFormIterator>
      </ArrayInput>
    </Root>
  )
}

export default ThenClauseForm
